import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllFgvsCommand } from '@/app/fgv/commands/get-all-fgvs.command'

const httpClient = new AxiosClient()

export const getAllFgvsCommand = new GetAllFgvsCommand(httpClient, store)
